import {
    GET_CUSTOMER_LIST_PROGRESS, GET_CUSTOMER_LIST_SUCCESS, GET_CUSTOMER_LIST_FAILURE,
    ADD_CUSTOMER_PROGRESS, ADD_CUSTOMER_SUCCESS, ADD_CUSTOMER_FAILURE,
    EDIT_DELETE_CUSTOMER_PROGRESS, EDIT_DELETE_CUSTOMER_SUCCESS, EDIT_DELETE_CUSTOMER_FAILURE,
   
    RESET_MESSAGE,

} from '../types/actionTypes';

const initialState = {
    customer: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const customer_reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CUSTOMER_LIST_SUCCESS:
            return { ...state, customer: action.customer, loading: false };
        case GET_CUSTOMER_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_CUSTOMER_LIST_PROGRESS:
            return { ...state, loading: true, error: false };
        case ADD_CUSTOMER_PROGRESS:
            return { ...state, loading: true };
        case ADD_CUSTOMER_SUCCESS:
            return { ...state, customer: [...state.customer, action.payload], loading: false, error: false, message: 'Record saved successfully!' };
        case ADD_CUSTOMER_FAILURE:
            return { ...state, loading: false, error: action.payload, message: 'Failed to save the record, try again!' };
        case EDIT_DELETE_CUSTOMER_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_CUSTOMER_SUCCESS:
            return {
                ...state,
                customer: state.customer.map((customer) =>
                customer._id === action.payload._id ? action.payload : customer
                ),
                message: action.payload.is_deleted === 1 ? 'Record deleted successfully!' : 'Record updated successfully!'
            };
        case EDIT_DELETE_CUSTOMER_FAILURE:
            return { ...state, loading: false, error: action.payload, message: 'Failed to update the record, try again!' };
     
        case RESET_MESSAGE:
            return { ...state, message: null }; // Reset the edit message

        default:
            return state
    }
}

export default customer_reducer;